import React, { Component } from 'react';
import CelaneseAPI from '../../services';
import config, { utils } from '../../config';
import { message, Select, Button, Radio } from 'antd';
import PropTypes from 'prop-types';
import './AddCompany.css';
import { connect } from 'react-redux';
import { getCompaniesData } from '../../actions/index';
import Translation from '../../Translation';

const Option = Select.Option;
/**
 *
 * Class for adding a company in Manage companies.
 *
 * @class AddCompany
 * @extends {Component}
 */
class AddCompany extends Component {
    constructor(props) {
        super(props);

        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.addNewCompany = this.addNewCompany.bind(this);
        this.state = {
            selectedCompany: '',
            loading: false,
            editCompanyData: this.props.editCompanyData || '',
            regionValue: ''
        };
    }
    /**
     * Success function is for showing success message when company is added successfully.
     *
     * @memberof AddCompany
     */
    success = () => {
        message.success( utils.getTranslationText('msg_company_success_added', 'Company successfully added.'), 1);
    };
    /**
     * Error function is for showing error message when company is not added successfully.
     *
     * @memberof AddCompany
     */
    error = (err) => {
        message.error(err || utils.getTranslationText('msg_some_issue', 'There was some issue.') , 1);
    };

    /**
     *Warning function is for showing warning message when field is left empty
     *
     * @memberof AddCompany
     */
    warning = () => {
        message.warning( utils.getTranslationText('msg_field_is_empty', 'The field is empty'), 1);
    };

    /**
     *duplicateWarning function is for showing warning message when trying to add an already existing company.
     *
     * @memberof AddCompany
     */
    duplicateWarning = () => {
        message.warning( utils.getTranslationText('msg_already_existing', 'You are trying to add an already existing company'), 1);
    }
    /**
     * handleSelectChange function will clone the selected companies tow items to a new company that user creates.
     * 
     * @param {String} value which is string, it will take selected value from the select dropdown.
     * @memberof AddCompany
     */
    handleSelectChange = (value) => {
        let data = this.props.allCompanies || [];
        let result = data.find(element => element === value);
        if (result) {
            this.setState({
                selectedCompany: result
            });
        }
    }
    /**
     * handleEdit function is for editing the region for the company
     */
    handleEdit() {
        if(!this.state.regionValue) {
            this.error( utils.getTranslationText('msg_region_mandatory', 'Region Name is Mandatory'));
            return;
        }
        let companyData = this.state.editCompanyData;
        if(companyData && companyData.id) {
            this.setState({
                loading: true
            });
            let newData = {
                company: companyData.company,
                region: this.state.regionValue,
                id: companyData.id
            }
            let promiseObj;
            if (newData.id) {
                promiseObj = CelaneseAPI.patch(config.API.updateCompanies.replace(':id', newData.id), newData);
            } else {
                promiseObj = CelaneseAPI.post(config.API.companies, newData);
            }
            this.promiseFunc(promiseObj);
        }
    }
    /**
     * handleAdd function will check for duplicate company if it succeeds then we proceed to add new company
     * 
     * @returns
     * @memberof AddCompany
     */
    handleAdd() {
        let companyValue = document.getElementById('add-new-company-text').value;
        let selectedCompanyName = this.state.selectedCompany;
        if (this.props.allCompanies.includes(companyValue)) {
            this.duplicateWarning();
            return;
        }
        let obj = {
            companyValue: companyValue,
            selectedCompanyData: [],
            id: '',
            region: this.state.regionValue
        }
        if (!obj.companyValue.trim() || !obj.region) {
            if(!obj.companyValue.trim() && !obj.region) {
                this.error( utils.getTranslationText('msg_company_region_mandatory', 'Company and Region names are Mandatory'));
            } else if(!obj.companyValue.trim()) {
                this.error( utils.getTranslationText('msg_company_name_mandatory', 'Company Name is Mandatory'));
            } else if(!obj.region) {
                this.error( utils.getTranslationText('msg_region_mandatory', 'Region Name is Mandatory'));
            }
            return;
        }
        this.setState({
            loading: true
        });
        if (selectedCompanyName) {
            let data = this.props.rows ? this.props.rows.filter(element => { return selectedCompanyName === element.company }) : null;
            if (data && data[0].items) {
                obj.selectedCompanyData = data[0].items;
                obj.id = data[0].id;
            }
        }
        let newData = {
            company: obj.companyValue,
            items: obj.selectedCompanyData || [],
            users: [],
            region: obj.region
        };
        this.addNewCompany(newData);
    }
    /**
     * addNewCompany function accepts a object of new company name and adds new company
     * 
     * @param {object} obj
     * @memberof AddCompany
     */
    addNewCompany(newData) {
        let promiseObj;
        if (newData.id) {
            promiseObj = CelaneseAPI.post(config.API.cloneCompany.replace(':id', newData.id), newData);
        } else {
            promiseObj = CelaneseAPI.post(config.API.companies, newData);
        }
        this.promiseFunc(promiseObj);
    }
    promiseFunc(promiseObj) {
        promiseObj.then(res => {
            if (!res.error) {
                if(document.getElementById('add-new-company-text')) {
                    document.getElementById('add-new-company-text').value = '';
                }
                this.success( utils.getTranslationText('msg_company_edited_successfully', 'Company edited Successfully'));
                this.updateStoreData();
                this.setState({
                    loading: false
                }, function () {
                    this.props.handleCompanyCancel();
                });
            }
        }).catch(() => {
            this.error();
        });
    }
    /**
     * updateStoreData function is for updatng the data in redux/store - event is dispatched here.
     * 
     * @memberof AddCompany
     */
    updateStoreData = () => {
        getCompaniesData().then(res => {
            return res;
        });
    }

    /**
     * toggleRegion function is for getting the name of the region while adding a new company
     * 
     * @memberof AddCompany
     */
    toggleRegion = (e) => {
        this.setState({
            regionValue: e.target.value
        })
    }

    componentWillMount() {
        const companyData = this.state.editCompanyData;
        if(companyData && companyData.id) {
            this.setState({
                selectedCompany: companyData.company,
                regionValue: companyData.region || ''
            });
        }
    }

    render() {
        const childrenFilter = [];
        const dataFilter = this.props.allCompanies ? this.props.allCompanies : [];
        const editCompanyId = this.state.editCompanyData && this.state.editCompanyData.id ? this.state.editCompanyData.id : '';
        for (let i = 0; i < dataFilter.length; i++) {
            childrenFilter.push(<Option key={i} value={dataFilter[i]}>{dataFilter[i]}</Option>);
        }
        return (
            <div className="add-comapny">
                { !editCompanyId ? 
                    <h3><Translation labelName="btn_add_new_company" defaultText="Add New Company"/></h3> : <h3><Translation labelName="hdr_edit_company" defaultText="Edit Company"/></h3>
                }
                <div className="add-company__form">
                    <label><span className="required-field-asterick">*</span><Translation labelName="lbl_name" defaultText="Name"/></label>
                    { editCompanyId ? 
                        <input
                            type="text"
                            id="add-new-company-text"
                            value={editCompanyId ? this.state.editCompanyData.company : ''}
                            readOnly={true}
                            autoComplete="off" /> : 
                        <input
                            type="text"
                            id="add-new-company-text"
                            autoComplete="off" />
                    }
                </div>
                <div className="add-company__form region-wrapper">
                    <label><span className="required-field-asterick">*</span><Translation labelName="lbl_Region" defaultText="Region"/></label>
                    <Radio.Group size="small" value={this.state.regionValue} onChange={this.toggleRegion} style={{ marginBottom: '10px' }} buttonStyle="solid">
                        <Radio value="NA"><Translation labelName="rdo_Na" defaultText="NA"/></Radio>
                        <Radio value="LA"><Translation labelName="rdo_La" defaultText="LA"/></Radio>
                        <Radio value="EMEA"><Translation labelName="rdo_Emea" defaultText="EMEA"/></Radio>
                        <Radio value="AP"><Translation labelName="rdo_Ap" defaultText="AP"/></Radio>
                    </Radio.Group>
                </div>
                { !editCompanyId ? 
                <div className="add-company__form">
                    <label><Translation labelName="lbl_clone_cmpy" defaultText="Clone From Company (Optional)"/></label>
                    <Select
                        className="col-md-12"
                        onSelect={this.handleSelectChange}
                        placeholder={<Translation labelName="lbl_please_select" defaultText="Please Select" />}>
                        {childrenFilter}
                    </Select>
                </div> : null }
                <div>
                    { !editCompanyId ?
                    <Button type="primary" className="btn btn-default clone-company-link" loading={this.state.loading} onClick={this.handleAdd}>
                    <Translation labelName="btn_add" defaultText="ADD"/>
                    </Button> :
                    <Button type="primary" className="btn btn-default clone-company-link" loading={this.state.loading} onClick={this.handleEdit}>
                       <Translation labelName="btn_update" defaultText="UPDATE"/>
                    </Button> }
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ companiesState }) => ({
    companiesData: companiesState.companiesData
});

const mapDispatchToProps = dispatch => ({
    getCompaniesData: (data) => dispatch(getCompaniesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddCompany);

AddCompany.propTypes = {
    companiesData: PropTypes.any,
    getCompaniesData: PropTypes.func,
    handleCompanyCancel: PropTypes.func,
    allCompanies: PropTypes.array,
    rows: PropTypes.array
}


// WEBPACK FOOTER //
// ./src/components/AddCompany/index.js